import { GetTipologieAssetQuery } from '../../_graphql/generated';

export type TipologiaAssetState = {
  loading: boolean;
  lista: GetTipologieAssetQuery['energy_village_tipologia_asset'];
  failure: any;
};

export const initialTipologiaAssetState: TipologiaAssetState = {
  loading: false,
  lista: [],
  failure: '',
};
